import { produce as immerProduce, isDraft } from 'immer';
export function produce(base, recipe) {
  if (isDraft(base)) {
    recipe(base);
    return base;
  } else {
    return immerProduce(base, recipe);
  }
}